import { makeAutoObservable } from 'mobx';
import {
	IEntityAPI,
	IEntityColumn,
	IFieldOption,
	IGenericEntity,
	IUserConfigPackage,
} from '../API';

export class FilterOptionsState {
	private getApi: () => Promise<IEntityAPI<IGenericEntity>>;
	public userConfig: IUserConfigPackage;
	private parentId: string = '';

	public show: boolean = false;
	public loading: boolean = true;
	public columnInfo: IEntityColumn;
	public filterOptions: IFieldOption[] = [];
	public selectedFilterOptions: IFieldOption[] = [];

	public hasExpanded: boolean = false;

	constructor(
		columnInfo: IEntityColumn,
		parentId: string,
		getApi: () => Promise<IEntityAPI<IGenericEntity>>,
		userConfig: IUserConfigPackage,
	) {
		this.columnInfo = columnInfo;
		this.getApi = getApi;
		this.userConfig = userConfig;
		this.parentId = parentId;
		makeAutoObservable(this);
	}

	public async expandFilterOptions(show: boolean): Promise<void> {
		this.show = show;

		if (show && !this.hasExpanded) {
			this.hasExpanded = true;
			let filterOptions = await (
				await this.getApi()
			).filterOptions(this.columnInfo.id, this.parentId);
			this.filterOptions = filterOptions;
			this.loading = false;
		}
	}

	public addFilterOption(fieldOption: IFieldOption): void {
		this.selectedFilterOptions.push(fieldOption);
	}

	public removeFilterOption(fieldOption: IFieldOption): void {
		this.selectedFilterOptions.splice(
			this.selectedFilterOptions.findIndex(
				(filter) => filter.internal_value === fieldOption.internal_value,
			),
			1,
		);
	}

	public setFilterOptions(fieldOptions: IFieldOption[]): void {
		this.selectedFilterOptions = fieldOptions;
	}

	public setFilterOptionDates(dateLower: Date, dateUpper: Date): void {
		const lowerValue = {
			display_value: '',
			internal_value: dateLower.toISOString(),
		} as IFieldOption;

		const upperValue = {
			display_value: '',
			internal_value: dateUpper.toISOString(),
		} as IFieldOption;

		this.setFilterOptions([lowerValue, upperValue]);
	}

	public isChecked(value: string): boolean {
		return (
			this.selectedFilterOptions.findIndex(
				(option) => option.internal_value === value,
			) >= 0
		);
	}

	public clearOptions() {
		this.selectedFilterOptions = [];
	}
}
